module.exports = __webpack_public_path__ + "img/elevator-box.330183e9.png";